import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Input,
    Label,
    Button,
    CustomInput,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    InputGroupText,
    InputGroupAddon,
    InputGroup,
} from 'reactstrap';
import { Colxx } from '../../../../../../../components/common/CustomBootstrap';
import moment from 'moment';
import { AxiosAPI, getGroupID } from '../../../../../../../helpers/AxiosAPI';
import {
    API_Vouchers_Codes,
    gAPI_QuestionOptionList,
    gAPI_RatePlans_List,
    gAPI_Rooms_List,
    API_Xola,
} from '../../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Axios from 'axios';
import Validation from '../../../../../../../components/Validation';
function GenerateCodes({
    visible,
    toggle,
    formLabel,
    handleLoadData,
    voucherName,    
    id,
    propertyId,   
}) {    
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [codeData, setCodeData] = useState({        
            groupId: getGroupID(),
            propertyId: propertyId,  
            voucherId:id,                                  
            purpose: '',
            quantity: 0,
            optionName: '',            
        }
    );
    


    const handleSubmit = () => {  
        AxiosAPI({
            url:API_Vouchers_Codes,
            method:'post',
            data:codeData
        }).then((res) => {
            if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                && res.data.Messages !== null && res.data.Messages.length > 0) {
                setMsg(res.data.Messages);
                setOpen(true);
            }
            else {
            toggle();
            handleLoadData();
            }
        });  
    };

    return (
        <Fragment>
            <Modal
                isOpen={visible}
                toggle={toggle}
                size="lg"
                style={{ maxWidth: '1000px' }}
            >
                <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
                <ModalBody>
                    <Fragment>
                        <Fragment>
                            <Row>
                                <Colxx sm={9} className="mb-3">
                                    <Label>Voucher</Label>
                                    <Input
                                        disabled={true}
                                        type="text"
                                        name="option"
                                        value={voucherName}
                                    />
                                </Colxx>
                                {/* <Colxx sm={6} className="mb-3">
                                    <Label>Option</Label>
                                    <Input
                                        required
                                        type="text"
                                        name="option"
                                        value={codeData.optionName}
                                        onChange={(event) =>
                                           setCodeData({...codeData,optionName:event.target.value})
                                        }
                                    />
                                </Colxx> */}
                                <Colxx sm={3} className="mb-3">
                                    <Label>Quantity</Label>
                                    <Input
                                        type="number"
                                        min={0}
                                        value={codeData.quantity}
                                        name="price"
                                        onChange={(event) =>
                                            setCodeData({...codeData,quantity:event.target.value})
                                        }
                                    />
                                </Colxx>
                                <Colxx sm={6} className="mb-3">
                                    <Label>Purpose</Label>
                                    <InputGroup>
                                        <Input
                                            type="text"
                                            min={0}
                                            value={codeData.purpose}
                                            name="purpose"
                                            onChange={(event) =>
                                                setCodeData({...codeData,purpose:event.target.value})
                                            }
                                        />                                    
                                    </InputGroup>
                                </Colxx>
                             </Row>
                        </Fragment>
                    </Fragment>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => { handleSubmit(); }}>
                        Save
                    </Button>
                    <Button
                        color="secondary"
                        onClick={() => {
                            //setVoucherData({ ...voucherData, sellingOptions: [] });
                            toggle();
                        }}
                    >
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            {/* {!update && handleAddOptions()} */}
            <Validation open={open} messages={msg} toggle={()=>{setOpen(!open)}}></Validation>
        </Fragment>
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId,
        locale,
    };
};
export default injectIntl(connect(mapStateToProps)(GenerateCodes));
